import './onboardingIntro.scss';

interface OnboardingIntroProps {
  name?: string;
  description: string;
}

const OnboardingIntro = ({ name, description }: OnboardingIntroProps) => {
  const normalizedName = name?.trim();

  return (
    <div className="w-100">
      <h1 className="chat-onboarding__title mb-0">
        WELCOME BACK
        {normalizedName ? `, ${normalizedName.toUpperCase()}` : ''}
      </h1>
      <p className="chat-onboarding__description mb-0">{description}</p>
    </div>
  );
};

export default OnboardingIntro;
